module.exports = __webpack_public_path__ + "static/turquoisemedia-b0b16ee3fdb097d54a7ce79e11b3298d.jpg";